import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-video-preview-data.interface';
import { VideoFormat } from '../../../../../../../utils/youtube-format-helper';
import { YoutubeShortsAdMobileShellComponent } from './youtube-shorts-ad-mobile-shell.component';

/**
 * Shorts ad for the 1:1 creative: centred square, with a blurred copy of itself
 * filling the bands above and below — what the Shorts player does with any
 * creative that is not vertical.
 */
@Component({
    selector: 'app-gen-youtube-shorts-ad-mobile-square',
    imports: [YoutubeShortsAdMobileShellComponent],
    template: '<app-gen-youtube-shorts-ad-mobile-shell [data]="data" [format]="format" />',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class YoutubeShortsAdMobileSquarePreviewComponent {
  @Input() data!: GenVideoPreviewData;

  readonly format: VideoFormat = '1:1';
}
